function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, visibility) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'is-closed': $helpers.isClosed(),
          'is-fullscreen': !$attr(`not-fullscreen`),
        }, {
          'mp-modal': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.showBackdrop()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              mousedown: $helpers.handleBackdropClick,
            },
            "class": Object.assign({}, {
              [`is-${visibility}`]: true,
            }, {
              'mp-modal-backdrop': true
            }),
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            elref: 'contentBody',
          }),
          "on": {
            mousedown: $helpers.handleBackdropClick,
          },
          "class": Object.assign({}, {
            [`is-${$attr(`modal-type`)}`]: true,
            [`is-${$attr(`vertical-alignment`)}-aligned`]: true,
            [`is-${visibility}`]: true,
          }, {
            'mp-modal-wrapper': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              role: `dialog`,
              'aria-labelledby': $attr(`modal-title`),
              'aria-describedby': $attr(`modal-description`),
              'aria-modal': true,
            }),
            "on": {
              mousedown: ev => ev.stopPropagation(),
            },
            "class": Object.assign({}, {
              [`is-${$attr(`modal-type`)}`]: true,
              ['is-variable-width']: $attr(`grow-to-content`),
            }, {
              'mp-modal-main': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($attr(`closeable`) && !$attr(`hide-close-button`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `tertiary`,
                  icon: `x`,
                }),
                "on": {
                  click: $helpers.handleCloseClick
                },
                "class": {
                  'mp-modal-close-button': true
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined); /*  modal body */
            __jade_nodes = __jade_nodes.concat(h("slot"));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "visibility" in locals ? locals.visibility : typeof visibility !== "undefined" ? visibility : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;